import styled, { CSSObject, css } from 'styled-components';
import { colors } from 'AppV2/styles/colors';

export type Variation = 'primary' | 'secondary' | 'green' | 'blueLight' | 'red';

interface Props {
  iconStyle?: CSSObject;
  styles?: CSSObject;
  variation?: Variation;
}

export const MessageBoxContent = styled.div<Props>`
  display: flex;
  align-items: center;
  gap: 12px;

  width: 100%;
  height: auto;
  padding: 12px;
  border: 1px solid transparent;
  border-radius: 6px;

  .icon-content {
    display: grid;
    place-items: center;
    height: 100%;
    svg {
      color: ${colors.purple};
      width: 24px;
      min-width: 24px;
      height: 24px;
      ${({ iconStyle }) => iconStyle};
    }
  }

  .message-content {
    h6 {
      font-size: 16px;
      font-weight: 600;
      line-height: 18px;
      margin-bottom: 4px;
    }

    p {
      font-size: 14px;
      line-height: 22px;
      margin-bottom: 0px;
      text-align: left;
    }
  }

  ${({ variation, iconStyle }) => {
    if (variation === 'primary') {
      return css`
        border-color: ${colors.purple};
        background-color: ${colors.lightPurple};
        .icon-content {
          svg {
            color: ${colors.text200};
            ${iconStyle};
          }
        }
        .message-content {
          h6 {
            color: ${colors.text200};
          }

          p {
            color: ${colors.text200};
          }
        }
      `;
    }

    if (variation === 'secondary') {
      return css`
        border-color: ${colors.faded};
        background-color: ${colors.background200};
        .icon-content {
          svg {
            color: ${colors.text300};
            ${iconStyle};
          }
        }
        .message-content {
          h6 {
            color: ${colors.text300};
          }

          p {
            color: ${colors.text300};
          }
        }
      `;
    }

    if (variation === 'green') {
      return css`
        border-color: ${colors.greenDark};
        background-color: ${colors.green100};
        .icon-content {
          svg {
            color: ${colors.greenDark};
            ${iconStyle};
          }
        }
        .message-content {
          h6 {
            color: ${colors.greenDark};
          }

          p {
            color: ${colors.greenDark};
          }
        }
      `;
    }

    if (variation === 'blueLight') {
      return css`
        border-color: ${colors.blueLight500}10;
        background-color: ${colors.blueLight500}10;
        .icon-content {
          svg {
            color: ${colors.blue};
            ${iconStyle};
          }
        }
        .message-content {
          h6 {
            color: ${colors.blue};
          }

          p {
            color: ${colors.blue};
          }
        }
      `;
    }

    if (variation === 'red') {
      return css`
        border-color: ${colors.red}10;
        background-color: ${colors.red500}10;
        .icon-content {
          svg {
            color: ${colors.red};
            ${iconStyle};
          }
        }
        .message-content {
          h6 {
            color: ${colors.red};
          }

          p {
            color: ${colors.red};
          }
        }
      `;
    }
  }}

  ${({ styles }) => styles};

  @media screen and (max-width: 480px) {
    .message-content {
      h6 {
        font-size: 14px;
      }
      p {
        font-size: 12px;
      }
    }
  }
`;
